import { apiClient } from 'pobble-components/dist/api'

const apiEmailAuth = data => apiClient.post('/v3/email_authentication', data)

const apiEmailSignUp = (data, params) =>
  apiClient.post('/v3/email_signup', data, { params })

const apiForgot = email => apiClient.post('/v3/forgot', { email })

const apiCreateEmailIdentity = data =>
  apiClient.post('/v3/me/email_identities', data)

const apiUpdatePassword = (id, data) =>
  apiClient.put(`/v3/email_identities/${id}/update_password`, data)

export {
  apiEmailAuth,
  apiEmailSignUp,
  apiForgot,
  apiCreateEmailIdentity,
  apiUpdatePassword
}
